import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clearNull'
})
export class ClearNullPipe implements PipeTransform {

  transform(value: string | null): string {
    return value === null ? '' : value;
  }

}
